<template>
  <div class="page-3-container">
    <div class="lottie-wrapper">
      <v-lottie-player 
        :animationData="require('@/assets/images/message/message-sent.json')"
        autoplay
        loop
        width="100%"
        height="100%"
      />
    </div>
  </div>
</template>

<script>
import VueLottiePlayer from "vue-lottie-player"
import { mapState } from "vuex"

export default {
  components: {
    vLottiePlayer: VueLottiePlayer
  },
  emits: ['change-page'],
  computed: {
    ...mapState('trackingTemp', ['isApiFetching'])
  },
  mounted() {
    this.$store.dispatch('trackingTemp/setIsAnimationLoading', true)
    setTimeout(() => {
      if (!this.isApiFetching) {
        this.$emit('change-page', 4)
      } else {
        this.$store.dispatch('trackingTemp/setIsAnimationLoading', false)
      }
    }, 5000)
  },
}
</script>
